import React, { createContext, useContext } from 'react';
import useGcpIpHook from '../../../hooks/Dashboard/gcp/useIp';

export const GcpIpContext = createContext();

export const GcpIpProvider = ({ children }) => {
  const data = useGcpIpHook(); // Import everything from the hook

  return (
    <GcpIpContext.Provider value={data}>
      {children}
    </GcpIpContext.Provider>
  );
};

export const useGcpIp = () => useContext(GcpIpContext);